import React from "react"
import { FormattedMessage } from "react-intl"
import QuoteToInvoiceConversionToggleComponent from "../../automation/components/QuoteToInvoiceConversionToggleComponent"
import UnpaidInvoiceReminderComponent from "../../automation/components/UnpaidInvoiceReminderComponent"
import AssignmentRulesContainer from "../../automation/components/AssignmentRuleContainer"

const AutomatedSettingsSection = () => {
    return (
        <>
            <div>
                <div className="row">
                    <div className="col-12">
                        <div className="row">
                            <div className="col-8">
                                <h2 className="m-0 custom-lead">
                                    <FormattedMessage
                                        id='settings.automation_settings'
                                        defaultMessage='Automation Settings'
                                    />
                                </h2>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div>
                <div className="row ui-has-modules">
                    <div className="col-12 ui-module">
                        <QuoteToInvoiceConversionToggleComponent />
                        <AssignmentRulesContainer />
                        <UnpaidInvoiceReminderComponent />
                    </div>
                </div>
            </div>

        </>
    )
}

export default AutomatedSettingsSection


// WEBPACK FOOTER //
// ./src/settings/section/AutomatedSettingsSection.tsx